require('./components/anchors.js');
require('./components/scroll.js');
require('./components/nav.js');
require('./components/animate-active.js');
